import { styled } from "styled-components";
const MultiSelectWrapper = styled("div")(({ theme }) => ({
  flex: "1 1 0",
  fontFamily: theme.fontFamily.default,
  fontSize: theme.fontSize.default,
  fontWeight: theme.fontWeight.normal,
  minWidth: 150,
  position: "relative"
}));
const MultiSelectInner = styled("div")({
  position: "relative"
});
styled("div")(({ theme }) => ({
  borderBottom: `1px solid ${theme.borderColor}`
}));
const MultiSelectMenu = styled("div")({
  outline: 0,
  position: "relative",
  transformOrigin: "inherit"
});
const MultiSelectDropdownBox = styled("div")(({ theme }) => ({
  backgroundColor: "white",
  boxSizing: "border-box",
  borderRadius: 2,
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
  color: theme.color.default,
  fontFamily: theme.fontFamily.default,
  fontSize: theme.fontSize.default,
  lineHeight: theme.lineHeight.default,
  outline: 0,
  position: "relative",
  transformOrigin: "inherit"
}));
const MultiSelectPanel = styled("div")(
  {
    display: "flex",
    flexDirection: "column"
  },
  ({ $menuHeight }) => ({ maxHeight: $menuHeight })
);
const MultiSelectPanelHead = styled("div")(({ theme }) => ({
  borderBottom: `1px solid ${theme.borderColor}`,
  boxSizing: "content-box",
  flex: "0 0 auto",
  padding: 2
}));
const MultiSelectPanelBody = styled("div")({
  flex: "1 1 auto",
  outline: 0,
  overflow: "auto",
  padding: 4
});
const MultiSelectPanelFoot = styled("div")(({ theme }) => ({
  borderTop: `1px solid ${theme.borderColor}`,
  boxSizing: "content-box",
  flex: "0 0 auto",
  padding: "8px 12px"
}));
const MultiSelectList = styled("ul")({
  listStyle: "none",
  margin: "0 -2px",
  padding: "0 2px"
});
const MultiSelectVoid = styled("div")(({ theme }) => ({
  color: theme.color.gray6,
  padding: "4px 8px",
  wordBreak: "break-all"
}));
export {
  MultiSelectDropdownBox,
  MultiSelectInner,
  MultiSelectList,
  MultiSelectMenu,
  MultiSelectPanel,
  MultiSelectPanelBody,
  MultiSelectPanelFoot,
  MultiSelectPanelHead,
  MultiSelectVoid,
  MultiSelectWrapper
};
